<template >
  <v-toolbar-items> 
    <v-btn class="announcement-toggle" flat dark
      @click.stop="showAnnouncements">
      <v-badge :value="unreadCount"  color="red">
        <template v-slot:badge>
          <div dark>{{unreadCount}}</div>
        </template>
        <v-icon dark :class="hasImportantNotification ? 'ringBell' : ''">
          notifications
        </v-icon>
      </v-badge>
    </v-btn>
    <v-dialog 
      v-model="dialog"
      width="800"
      scrollable
      persistent
      @keydown.esc="closeAnnouncements"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title class="mx-auto">{{$t('notification')}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid style="min-height: 100px;" grid-list-lg v-if="!isComponentMode">
            <v-tabs
              v-if="(allAnnouncementKeys.length + notifications.length) && dialog"
              color="transparent"
              v-model="tab"
              show-arrows
              primary
              >
              <v-tab
                v-for="announcementKey of announcementsMapKey"
                :key="announcementKey"
                class="announcement-tab"
                ripple
              >
                <v-badge :value="getUnreadCountByKey(announcementKey)"
                  small
                  color="red">
                  <template v-slot:badge>
                    <div dark></div>
                  </template>
                  {{announcementKey !== 'general' ? announcementsMap.get(announcementKey)[0].broadcasterName : 'General'}}
                </v-badge>      
              </v-tab>
              <v-tab-item
                v-for="announcementKey in announcementsMapKey"
                :key="announcementKey"
              >
                <v-layout row wrap v-if="announcementKey === 'general'">
                  <v-flex xs12 v-for="notification in notifications" :key="notification.key">
                    <v-card hover raised @click="clickNotification(notification)">
                      <v-card-text >
                        <div class="cardTitle">You have {{notification.displayName}}</div>
                        <div class="cardText"><a class="underline">Click to go to {{notification.pathName}} page</a></div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-else>
                  <v-flex xs12 v-for="(announcement, index) in announcementsMap.get(announcementKey)" :key="'announcement' + index">
                    <v-card hover raised>
                      <v-card-text>
                        <div class="cardTitle">{{ announcement.broadcasterName + '  ' + toDateString(announcement.startDate) }}</div>
                        <div class="cardText">{{ announcement.msgContent }}</div>
                        <v-layout v-if="(announcement.attachments || []).length" row wrap>
                          <FsFileChip
                            v-for="(file, index) in (announcement.attachments || [])"
                            :file="file"
                            :key="'file' + index"
                            width="100%"
                            aspect-ratio="1.7"
                            class="ma-2"
                          />
                        </v-layout>
                        <!-- <div v-if="announcement.isImportant">
                          <v-checkbox
                            class="isReadBtn"
                            @change="value => readAnnouncement(value, announcement)"
                            :label="$t('read')"
                          ></v-checkbox>
                        </div> -->
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs>
            <v-flex 
              v-else
              text-md-center
              md12>
              There is no notification now
            </v-flex>
          </v-container>
           <v-container fluid style="min-height: 100px;" grid-list-lg v-else>
              <v-layout row wrap>
                  <v-flex xs12 v-for="(announcement, index) in componentAnnouncements" :key="'announcement' + index">
                    <v-card hover raised>
                      <v-card-text>
                        <div class="cardTitle">{{ announcement.broadcasterName + '  ' + toDateString(announcement.startDate) }}</div>
                        <div class="cardText">{{ announcement.msgContent }}</div>
                        <v-layout v-if="(announcement.attachments || []).length" row wrap>
                          <FsFileChip
                            v-for="(file, index) in (announcement.attachments || [])"
                            :file="file"
                            :key="'file' + index"
                            width="100%"
                            aspect-ratio="1.7"
                            class="ma-2"
                          />
                        </v-layout>
                        <div v-if="announcement.isImportant">
                          <v-checkbox
                            class="isReadBtn"
                            @change="value => readAnnouncement(value, announcement)"
                            :label="$t('read')"
                          ></v-checkbox>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="closeAnnouncements">{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar-items>
</template>

<script>
import { timeTools } from '../utils/tools'
import FsFileChip from './FsFileChip'

export default {
  components: {
    FsFileChip
  },
  name: 'AnnouncementWidget',
  mixins: [timeTools],
  data () {
    return {
      dialog: false,
      tab: null,
      readingKeys: new Set(),
      isComponentMode: false,
      componentAnnouncements: []
    }
  },
  mounted () {
    this.$store.commit('setGlobalFunctions', { 
      showPathAnnouncement: this.showPathAnnouncement,
      checkPathAnnouncement: this.checkPathAnnouncement
    })
  },
  watch: {
    tab () {
      if (this.dialog) this.setUnReadTabKeysToReadList()
    },
    dialog (toggle) {
      if (!toggle) {
        this.$store.dispatch('updateUserExtraReadList', this.getTotalReadList())
          .then(() => {
            this.readingKeys.clear()
          })
      } else {
        if (this.unReadTabKeys.length > 0) this.setUnReadTabKeysToReadList()
      }
    },
    currentPath (value) {
      if (
        this.allPathAnnouncements.some(
          announcement => !this.announcementsReadList.includes(announcement._key) 
            && (!announcement?.paths?.length || announcement.paths.includes(value))
        )) {
        this.showPathAnnouncement(value)
      }
    }
  },
  computed: {
    announcementsMap () {
      const newAnnouncementMap = new Map()
      for (const [key, announcements] of this.$store.getters.announcementsMap) {
        newAnnouncementMap.set(key, announcements.filter(announcement => !announcement.paths || !announcement.paths.length))
      }
      return newAnnouncementMap
    },
    allPathAnnouncements () {
      const pathAnnouncements = []
      this.$store.getters.announcementsMap.forEach((announcements) => {
        announcements.forEach(announcement => {
          pathAnnouncements.push(announcement)
        })
      })
      return pathAnnouncements
    },
    announcementsMapKey () {
      let keys = []
      let sysInfoSign = false
      this.announcementsMap.forEach((announcements, key) => {
        if (key === 'sys' && announcements.length) {
          sysInfoSign = true
          return
        }
        if (announcements.length) keys.push(key)
      })
      if (sysInfoSign) keys = ['sys', ...keys]
      if (this.notifications.length) keys = ['general', ...keys]
      return keys
    },
    unReadTabKeys () {
      if (this.tab === 0 && this.announcementsMapKey.length && this.announcementsMapKey[0] === 'general') return []
      let broadcasterKey = this.announcementsMapKey[this.tab]
      let currentTabAnnouncements = this.isComponentMode ? this.componentAnnouncements : this.announcementsMap.get(broadcasterKey) || []
      return currentTabAnnouncements.filter(({_key}) => !this.announcementsReadList.includes(_key)).map(({_key}) => _key)
    },
    announcementsReadList () {
      return (this.$store.getters.userExtra || {}).announcementsReadList || []
    },
    unreadCount () {
      return this.allUnreadAnnouncements.length + this.notifications.length
    },
    allAnnouncementKeys () {
      return [...this.announcementsMap].reduce((keys, [key, announcements]) => [...keys, ...announcements.map(({_key}) => _key)], [])
    },
    allUnreadAnnouncements () {
      return this.allAnnouncementKeys.filter(key => !(this.announcementsReadList.includes(key) || this.readingKeys.has(key)))
    },
    notifications () {
      return this.$store.getters.notifications 
    },
    currentPath () {
      return this.$route.path
    },
    hasImportantNotification () {
      let importantAnnouncementsNum = 0
      this.announcementsMap.forEach(announcementsList => {
        if (announcementsList && announcementsList.length && announcementsList.some(item => item.isImportant && !this.announcementsReadList.includes(item._key))) {
          importantAnnouncementsNum += 1
        }
      })
      return !!importantAnnouncementsNum
    }
  },
  methods: {
    closeAnnouncements () {
      this.dialog = false 
      this.isComponentMode = false
    },
    showAnnouncements () {
      this.tab = null
      this.dialog = true
    },
    showPathAnnouncement (path) {
      this.componentAnnouncements = this.allPathAnnouncements.filter(
        announcement => 
          !this.announcementsReadList.includes(announcement._key) 
            && (!announcement?.paths?.length || announcement.paths.includes(path))
      )
      if (!this.componentAnnouncements.length) return
      this.dialog = true
      this.isComponentMode = true
    },
    checkPathAnnouncement (path) {
      return this.allPathAnnouncements.some(announcement => announcement.paths.includes(path))
    },
    getUnreadCountByKey (key) {
      if (key === 'general') {
        return this.notifications.length
      }
      return this.announcementsMap.get(key)
        .filter(({_key}) => this.allUnreadAnnouncements.includes(_key))
        .length || 0
    },
    setUnReadTabKeysToReadList () {
      this.unReadTabKeys.forEach(key => {
        let announcement = this.allPathAnnouncements.find(item => item._key === key)
        if (!announcement.isImportant) {
          this.readingKeys.add(key)
        }
      })
    },
    readAnnouncement (value, announcement) {
      let key = announcement._key
      if (value) {
        this.readingKeys.add(key)
      } else {
        this.readingKeys.delete(key)
      }
    },
    getTotalReadList () {
      return [...(new Set([
        ...(this.announcementsReadList.filter(key => this.allAnnouncementKeys.includes(key))),
        ...(this.announcementsReadList.filter(key => this.allPathAnnouncements.some(announcement => announcement._key === key))),
        ...this.readingKeys
      ]))]
    },
    clickNotification (notification) {
      this.dialog = false 
      this.$router.push({path: notification.path})
      if (notification.key === 'returnPackageNotifications') {
        const newNotification = this.notifications.filter(item => notification.key !== item.key)
        this.$store.commit('setNotifications', newNotification)
      }
    }
  }
}
</script>

<style>
.cardTitle {
  font-weight: bold;
  font-size: 15px;
}

.cardText {
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  width: 100%;
}
.announcement-tab .v-badge__badge{
  width: 8px;
  height: 8px;
  top: -6px;
  right: -10px;
}
.ringBell {
    transition: rotate 1s;
    animation-name: wave;
    animation-duration: .5s;
    animation-iteration-count: infinite;
}
.isReadBtn {
  display: flex;
  justify-content: end;
  height: 30px;
}
@keyframes wave {
    from {
        transform: rotate(0deg);
    }
    5% {
        transform: rotate(-5deg);
    }
    10% {
        transform: rotate(-10deg);
    }
    15% {
        transform: rotate(-15deg);
    }
    20% {
        transform: rotate(-20deg);
    }
    25% {
        transform: rotate(-30deg);
    }
    30% {
        transform: rotate(-20deg);
    }
    35% {
        transform: rotate(-15deg);
    }
    40% {
        transform: rotate(-10deg);
    }
    45% {
        transform: rotate(-5deg);
    }
    50% {
        transform: rotate(0deg);
    }
    55% {
        transform: rotate(5deg);
    }
    60% {
        transform: rotate(10deg);
    }
    65% {
        transform: rotate(15deg);
    }
    70% {
        transform: rotate(20deg);
    }
    75% {
        transform: rotate(30deg);
    }
    80% {
        transform: rotate(20deg);
    }
    85% {
        transform: rotate(15deg);
    }
    90% {
        transform: rotate(10deg);
    }
    95% {
        transform: rotate(5deg);
    }
    to {
        transform: rotate(0deg);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/AnnouncementWidget.vue